export default __webpack_public_path__ + "d6440668b9a5959d724e147ab4f06f33.svg";